export const links = [
	{
		id: 1,
		link: "Collections",
	},
	{
		id: 2,
		link: "Men",
	},
	{
		id: 3,
		link: "Women",
	},
	{
		id: 4,
		link: "About",
	},
	{
		id: 5,
		link: "Contact",
	},
];
